import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Zap, Activity, ShieldCheck } from 'lucide-react';
export function RevelationSection() {
  return <section className="py-24 bg-[#0f172a] relative border-y border-slate-800/50" data-id="element-212">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-213">
        <FadeIn data-id="element-214">
          <div className="text-center mb-16" data-id="element-215">
            <span className="text-emerald-400 font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-216">
              La Verdad Oculta
            </span>
            <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6" data-id="element-217">
              La ansiedad no se cura "pensando positivo"
            </h2>
            <p className="text-xl text-slate-400 max-w-2xl mx-auto" data-id="element-218">
              Es una respuesta biológica del cuerpo. Y como tal, tiene un "hack"
              biológico.
            </p>
          </div>
        </FadeIn>

        <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-3xl p-8 md:p-12 border border-slate-700 shadow-2xl relative overflow-hidden" data-id="element-219">
          {/* Decorative circuit/nerve lines */}
          <div className="absolute top-0 right-0 opacity-10 pointer-events-none" data-id="element-220">
            <svg width="400" height="400" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-221">
              <path d="M200 0V400M0 200H400M100 100L300 300M100 300L300 100" stroke="#10b981" strokeWidth="2" data-id="element-222" />
              <circle cx="200" cy="200" r="100" stroke="#10b981" strokeWidth="2" data-id="element-223" />
            </svg>
          </div>

          <div className="relative z-10" data-id="element-224">
            <FadeIn delay={100} data-id="element-225">
              <div className="flex flex-col md:flex-row gap-8 items-center mb-10" data-id="element-226">
                <div className="w-20 h-20 shrink-0 bg-emerald-500/10 rounded-2xl flex items-center justify-center border border-emerald-500/30" data-id="element-227">
                  <Activity className="w-10 h-10 text-emerald-400" data-id="element-228" />
                </div>
                <div data-id="element-229">
                  <h3 className="text-2xl font-bold text-white mb-3" data-id="element-230">
                    El Nervio Vago: Tu Freno de Mano
                  </h3>
                  <p className="text-slate-300 text-lg leading-relaxed" data-id="element-231">
                    Descubrimos que podés "hackear" tu nervio vago en{' '}
                    <strong className="text-emerald-400" data-id="element-232">
                      menos de 5 minutos
                    </strong>{' '}
                    usando estímulos físicos y respiratorios específicos.
                  </p>
                </div>
              </div>
            </FadeIn>

            <div className="grid sm:grid-cols-2 gap-6" data-id="element-233">
              <FadeIn delay={200} className="bg-slate-900/50 p-6 rounded-xl border border-slate-700/50" data-id="element-234">
                <Zap className="w-8 h-8 text-amber-400 mb-4" data-id="element-235" />
                <h4 className="text-lg font-bold text-white mb-2" data-id="element-236">
                  No necesitás 3 meses de terapia
                </h4>
                <p className="text-slate-400 text-sm" data-id="element-237">
                  Para dormir hoy, necesitás una intervención física directa que
                  corte el loop de cortisol.
                </p>
              </FadeIn>

              <FadeIn delay={300} className="bg-slate-900/50 p-6 rounded-xl border border-slate-700/50" data-id="element-238">
                <ShieldCheck className="w-8 h-8 text-emerald-400 mb-4" data-id="element-239" />
                <h4 className="text-lg font-bold text-white mb-2" data-id="element-240">
                  Protocolo de Emergencia
                </h4>
                <p className="text-slate-400 text-sm" data-id="element-241">
                  Técnicas que le dicen a tu cerebro primitivo:{' '}
                  <em className="text-slate-300" data-id="element-242">
                    "Estamos a salvo, podés soltar el control".
                  </em>
                </p>
              </FadeIn>
            </div>
          </div>
        </div>
      </div>
    </section>;
}